import React from 'react';
import { Linking } from 'react-native';
import Text from '_/space-management/components/Text';
import { colors } from '../constants/theme';

export default function renderTextWithLinks(text: string | null | undefined, hideLink = false, linkStyle?: any) {
  if (!text) return text;

  const markdownLinkRegex = /(\[[^\]]+\]\[[^\]]+\])/g;
  
  const parts = text.split(markdownLinkRegex);

  return parts.map((part, index) => {
    const match = part.match(/\[([^\]]+)\]\[([^\]]+)\]/);

    if (match) {
      const label = match[1];
      const url = match[2];

      return (
        <Text
          key={index}
          style={[{ color: colors.lightBlue, textDecorationLine: 'underline' }, linkStyle]}
          onPress={() => hideLink ? null : Linking.openURL(url)}
        >
          {label}
        </Text>
      );
    }

    return part;
  });
}
